import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import {
  fontMerriweather,
  fontRobotoCondensed,
  setFullViewportWidthStyles,
  theme,
} from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;

  inline-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    gap: 32px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;

  inline-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    gap: 20px;

    max-inline-size: 768px;
    margin-inline: auto;
    padding-inline: 40px;
  }

  ${theme.breakpoints.up("desktop")} {
    padding-inline: 0;
  }
`;
export const NewTag = styled.span`
  padding-block: 0;
  padding-inline: 2px;

  color: #ffffff;
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontMerriweather};
  font-style: italic;
  line-height: normal;

  border-radius: 2px;

  background: #eb4254;
`;

export const StyledBaseLink = styled(BaseLink)`
  display: flex;
  gap: 6px;
  align-items: center;

  padding-block-end: 7px;

  color: #2c4692;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontMerriweather};
  font-style: italic;
  border-block-end: 1px dashed #2c4692;
`;

export const SeriesArticleSectionTag = styled.div`
  display: flex;
  justify-content: center;
`;

export const Topic = styled.div`
  margin-block-end: 8px;
  > a {
    color: #4585ff;
    font-weight: 700;
    font-size: 13px;
    font-family: ${fontRobotoCondensed};
    line-height: normal;
    text-transform: uppercase;
  }
`;

export const Headline = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 24px;
  font-family: ${fontMerriweather};
  font-style: italic;
  line-height: 140%;
  text-align: center;
  ${theme.breakpoints.up("tablet")} {
    font-size: 32px;
    line-height: 140%;
  }

  ${theme.breakpoints.up("desktop")} {
    font-size: 40px;
  }
`;

export const Summary = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 13px;
  font-family: ${fontMerriweather};
  font-style: italic;
  line-height: 140%;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;

  ${theme.breakpoints.up("tablet")} {
    font-size: 18px;
  }
`;

export const UpdatedDate = styled.div`
  color: #666666;
  font-weight: 400;
  font-size: 11px;
  text-align: center;

  ${theme.breakpoints.up("tablet")} {
    font-size: 14px;
  }
`;

export const CoverImageContainer = styled.div`
  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 768px;
    margin-inline: auto;
  }
`;

export const CoverImage = styled.div`
  position: relative;
  aspect-ratio: 3/2;

  inline-size: 100%;
  block-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    aspect-ratio: 5/2;
  }

  ${theme.breakpoints.up("tablet")} {
    aspect-ratio: 21/9;
  }

  ${theme.breakpoints.only("mobile")} {
    ${setFullViewportWidthStyles()}
  }
`;
